import { styled } from '@obvio/app'

import { CenteredSection } from '../CenteredSection'

import type { ReactElement } from 'react'

const Footer = styled.footer`
  display: flex;
  justify-content: center;
  background-color: ${(theme) => theme.background};
  color: white;
`

export function EventFooter(): ReactElement {
  return (
    <CenteredSection>
      <Footer>©Fijewski Gallery All Rights Reserved.</Footer>
    </CenteredSection>
  )
}
